var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", { staticClass: "dashboard-block" }, [
    _c("h2", [_vm._v(_vm._s(_vm._f("sentenceCase")(_vm.$t("management"))))]),
    _vm._v(" "),
    _c("div", { staticClass: "panel panel-grey" }, [
      _c("div", { staticClass: "panel-body" }, [
        _c("div", { staticClass: "row row-clear-md-4" }, [
          _c("div", { staticClass: "col-xs-12 col-md-6 col-lg-4" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v(_vm._s(_vm._f("sentenceCase")(_vm.$t("management")))),
                ]),
                _vm._v(" "),
                _c("selectize", {
                  staticClass: "form-control selectize selectize-single",
                  attrs: {
                    name: "management",
                    disabled: _vm.$userIsManager,
                    options: _vm.managementOptions,
                    score: _vm.managementScoringCallback,
                    "fetch-results": _vm.fetchManagementCallback,
                    "fetch-more-results": _vm.fetchMoreMoreManagementCallback,
                  },
                  model: {
                    value: _vm.stateManagement,
                    callback: function ($$v) {
                      _vm.stateManagement = $$v
                    },
                    expression: "stateManagement",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6 col-lg-4" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v(_vm._s(_vm.$t("Booking Agent"))),
                ]),
                _vm._v(" "),
                _c("selectize", {
                  staticClass: "form-control selectize selectize-single",
                  attrs: { name: "manager", options: _vm.staffManagerOptions },
                  model: {
                    value: _vm.stateStaffManager,
                    callback: function ($$v) {
                      _vm.stateStaffManager = $$v
                    },
                    expression: "stateStaffManager",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6 col-lg-4" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("Notification Delivery"),
                ]),
                _vm._v(" "),
                _c("selectize", {
                  staticClass: "form-control selectize selectize-single",
                  attrs: {
                    name: "notification_preference",
                    "disable-delete": true,
                    disabled: _vm.haveNoManagement,
                    options: _vm.notificationPreferenceOptions,
                  },
                  model: {
                    value: _vm.stateNotificationPreference,
                    callback: function ($$v) {
                      _vm.stateNotificationPreference = $$v
                    },
                    expression: "stateNotificationPreference",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "panel-footer" },
        [
          _c(
            "ladda-button",
            {
              staticClass: "btn btn-sm btn-primary",
              attrs: { type: "submit", click: _vm.handleSaveChangesCallback },
            },
            [_vm._v("\n        Save Changes\n      ")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }